import e from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function s(r) {
  o(1, arguments);
  var t = e(r);
  return t.setSeconds(0, 0), t;
}
export {
  s as default
};
